import { useEffect } from 'react';
import { hitAudiencies } from 'components/corporatiu/Audiencies/audiencies-datalayer';
import { useButlletins } from 'hooks/corporatiu/useButlletins';
import { useModal } from 'hooks/corporatiu/useModal';
import Boto from 'components/corporatiu/Boto';
import Icona from 'components/corporatiu/Icona';
import styles from './avisbutlletins.module.scss';

const AvisAlta = (props) => {
    const { removeModal } = useModal();
    const timeModalAlta = 5000;

    useEffect(() => {
        const timeAlta = setTimeout(() => {
            removeModal();
        }, timeModalAlta);
        return () => {
            clearTimeout(timeAlta);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles.altaButlletins}>
            <Icona className={styles.iconaOk} icona='verificat' isBlanc={false} inline={true} />
            <div className={styles.contentInfo}>
                <p className={styles.textDestacat}>T&apos;has subscrit correctament al butlletí</p>
                <p>Ben aviat rebràs continguts que t&apos;informen, t&apos;inspiren i t&apos;acompanyen</p>
            </div>
        </div>
    );
};

const AvisBaixa = (props) => {
    const { id, titol } = props;
    const { removeSubscripcioButlleti } = useButlletins();
    const { removeModal } = useModal();

    const handleOnClickBaixa = () => {
        hitAudiencies('scClicBoto', { URL: window.location.href, identificadorClic: `Baixa butlletí: ${titol}` });
        removeSubscripcioButlleti(id);
        removeModal();
    };

    const handleOnClickCancela = () => {
        removeModal();
    };

    return (
        <div className={styles.baixaButlletins}>
            <div className={styles.content}>
                <p className={styles.textBaixa}>Segur que vols deixar de rebre aquest butlletí?</p>
                <div className={styles.contentBotons}>
                    <Boto
                        tag='button'
                        estil='ple3cat100'
                        className={styles.botoBaixa}
                        text="Dona'm de baixa"
                        onClick={handleOnClickBaixa}
                    />
                    <Boto
                        tag='button'
                        estil='ple3cat100'
                        className={styles.botoCancelaBaixa}
                        text='Cancel·la'
                        onClick={handleOnClickCancela}
                    />
                </div>
            </div>
        </div>
    );
};

const AvisButlletins = (props) => {
    const { tipus, estat, id, titol } = props;

    if (tipus === 'alta') {
        return <AvisAlta estat={estat} />;
    } else if (tipus === 'baixa') {
        return <AvisBaixa id={id} titol={titol} />;
    }
    return <></>;
};

export default AvisButlletins;
